import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { MainNavigation } from "./mainNavigation";
import { AppHeader } from "./header/AppHeader";
import { CommonHeader } from "./header/CommonHeader";
import Footer from "./footer/Footer";
import { StaticNotifications } from "../notification/staticNotifications/StaticNotifications";
import { EulaFooter, EulaHeader } from "../eula";
import {
  getShowEulaFooter,
  getShowEulaHeader,
} from "../../store/config.selectors";
import { getEulaHeaderHeight, getEulaFooterHeight } from "../../store/layout";

import "./Layout.scss";

const Layout = ({
  showUserInfo,
  showNavigation,
  showHeaderUnderline,
  showHelpLink,
  showLogOutLink,
  customHeader,
  children,
}) => {
  const eulaHeaderHeight = useSelector(getEulaHeaderHeight);
  const eulaFooterHeight = useSelector(getEulaFooterHeight);

  return (
    <div
      className="layout"
      style={{
        paddingTop: `${eulaHeaderHeight}px`,
        paddingBottom: `${eulaFooterHeight}px`,
      }}
    >
      {showUserInfo && <StaticNotifications />}
      {customHeader ? (
        customHeader()
      ) : (
        <AppHeader>
          <CommonHeader
            showUserInfo={showUserInfo}
            showHeaderUnderline={showHeaderUnderline}
            showLogOutLink={showLogOutLink}
            showHelpLink={showHelpLink}
          />
        </AppHeader>
      )}
      {showNavigation && <MainNavigation />}
      <main className="layout__container">{children}</main>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  showNavigation: PropTypes.bool,
  showUserInfo: PropTypes.bool,
  showHeaderUnderline: PropTypes.bool,
  showHelpLink: PropTypes.bool,
  showLogOutLink: PropTypes.bool,
  customHeader: PropTypes.func,
};

Layout.defaultProps = {
  showNavigation: true,
  showUserInfo: true,
  showHeaderUnderline: false,
  showHelpLink: false,
  showLogOutLink: false,
};

export const withLayout = (layoutConfig) => (Page) => (props) => {
  const showEulaHeader = useSelector(getShowEulaHeader);
  const showEulaFooter = useSelector(getShowEulaFooter);

  return (
    <Fragment>
      {showEulaHeader && <EulaHeader />}
      <Layout {...layoutConfig}>
        <Page {...props} />
      </Layout>
      {showEulaFooter && <EulaFooter />}
    </Fragment>
  );
};
